"use client";
import { getTranslation } from "@/i18n/get-translation";
import { useEffect } from "react";
import styles from './freshsales-request-a-demo-form.module.css';

interface IRequestADemoForm {
  locale: string;
}

export default function FreshsalesRequestADemoForm({ locale }: IRequestADemoForm) {
  const t = getTranslation(locale, "contactUs.contactForm");
  const componentClassPrefix = 'freshsales-request-a-demo-form';
  const formURLPrefix:string = 'https://medlucy.myfreshworks.com/crm/sales/web_forms/';

  useEffect(()=>{
    if (typeof window !== 'undefined') {
      const script: HTMLScriptElement = document.createElement("script");

      let scriptSrc = `${formURLPrefix}/e62a7db4703580541e3d80a3d2b9c51b62bff487ff6bc298bd49a5e3bebb32eb/form.js`;
      let scriptId = 'fs_e62a7db4703580541e3d80a3d2b9c51b62bff487ff6bc298bd49a5e3bebb32eb';

      if(locale === 'fr-lu') {
        scriptSrc = `${formURLPrefix}/18434619638098102960acecdc7e0ec6e3d53b162589767a50d053730e90cbe7/form.js`;
        scriptId = 'fs_18434619638098102960acecdc7e0ec6e3d53b162589767a50d053730e90cbe7';
      } 
      else if(locale === 'de-lu') {
        scriptSrc = `${formURLPrefix}/6d032a6e9efeeaca3262a35602b33301ee9e52f2d68f8e6650e7738693fc475e/form.js`;
        scriptId = 'fs_6d032a6e9efeeaca3262a35602b33301ee9e52f2d68f8e6650e7738693fc475e';
      }


      if(!document.getElementById(scriptId)){
        script.src = scriptSrc;
        script.id = scriptId;
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.getElementById("freshsales-request-a-demo-form-box")?.appendChild(script);
      }
    }
  },[locale])

  return (
    <div id="freshsales-request-a-demo-form-box" className={styles[componentClassPrefix]}></div>
  );
}
